import moment from "moment-timezone";
import { TimezoneOption } from "../timezones.types";

export const getDSTAwareAbbreviationFromTimezone = (
  timezone: TimezoneOption,
  date: string
) => {
  if (!moment.tz.names().includes(timezone.name)) return "";

  const m = moment.tz(date, timezone.name);

  if (!m.isValid()) return "";

  // e.g. "EST", "EDT"
  return m.format("z");
};

export default getDSTAwareAbbreviationFromTimezone;

